var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgYandex(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 9,
    height: 18,
    viewBox: "0 0 9 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#FFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M15.078 17.102L12.142 24H10l3.225-7.376c-1.516-.806-2.527-2.266-2.527-4.96C10.698 7.888 12.984 6 15.703 6h2.768v18h-1.853v-6.898h-1.54zm1.54-9.466h-.987c-1.492 0-2.936 1.033-2.936 4.028 0 2.895 1.324 3.827 2.936 3.827h.987V7.636z",
    transform: "translate(-167 -158) translate(157 152)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYandex);
export default __webpack_public_path__ + "static/media/yandex.721fde385756e3c2baa0f79f55132140.svg";
export { ForwardRef as ReactComponent };